export default "__VITE_ASSET__B2zoo152__"